import detailApiCall from './detail';
import edit from './edit';
import listApiCall from './list';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
  edit,
  delete: edit,
};

export default ApiCall;
